import { AuthCustomer } from '@getjust/api-schema';
import { atom } from 'jotai';

export const loginAtom = atom<AuthCustomer.AuthLoginResponseBody | undefined>(undefined);
